export const useCheckSubscriptionPermission = (benefitKey, actionName = 'This action') => {

  const checkPermission = () => {
    const splash = JSON.parse(localStorage.getItem('SplashData') || '{}');
  

    const userType = splash?.user?.user_type;
    if (userType !== 'industry') return true;

    const benefits =
      (Array.isArray(splash?.benefits) && splash.benefits) ||
      (Array.isArray(splash?.user?.benefits) && splash.user.benefits) ||
      (Array.isArray(splash?.user?.active_subscription?.benefits) && splash.user.active_subscription.benefits) ||
      (Array.isArray(splash?.active_subscription?.benefits) && splash.active_subscription.benefits) ||
      null;

    const activeSubscription =
      splash?.active_subscription ??
      splash?.user?.active_subscription ??
      null;

    if (activeSubscription === null && !benefits) {
      window.dispatchEvent(new CustomEvent('show-no-subscription-modal'));
      return false;
    }

    if (!benefits) return true;

    const key = String(benefitKey || '').trim().toLowerCase();
    const benefit = benefits.find(
      (b) => String(b?.benefit_key || '').trim().toLowerCase() === key
    );

    if (!benefit) return true;

    if (benefit.is_enabled !== true) {
      window.dispatchEvent(new CustomEvent('show-with-subscription-modal'));
      return false;
    }

    return true;
  };

  return checkPermission;
};
